import common from './common.json'
import core from './core.json'
import planning from './planning.json'
import app from './app.json'
import shared from './shared.json'
import views from './views.json'
import editor from './editor.json'
import workflows from './workflows.json'
import factbox from './factbox.json'
import event from './event.json'
import metaSheet from './metaSheet.json'
import flash from './flash.json'
import quickArticle from './quickArticle.json'
import errors from './errors.json'
import wires from './wires.json'
import print from './print.json'
import memo from './memo.json'

export const nb = {
  common,
  core,
  planning,
  app,
  shared,
  views,
  editor,
  workflows,
  factbox,
  event,
  metaSheet,
  flash,
  quickArticle,
  errors,
  wires,
  print,
  memo
}
